module.exports = __webpack_public_path__ + "img/posterSearch-des1.1183bb6a.png";